import styled from "styled-components";

export const StErrorMessage = styled.span`
    color: var(--color-negative);
    font-size: var(--font-body);
    font-weight: 400;
`